<ion-app>
  <ion-progress-bar [type]="'indeterminate'" *ngIf="loading"></ion-progress-bar>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
